export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            剧集投稿与商务合作
          </h2>
          <p className="text-foreground-500 text-sm mb-10 max-w-lg mx-auto">
            如果你有好剧推荐、片源合作或商务洽谈需求，欢迎通过以下方式联系我们。情侣影院期待与更多优质内容方合作。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-background-50 rounded-2xl p-6 border border-secondary-200/70">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-700 mb-2">剧集投稿</h3>
              <p className="text-foreground-500 text-sm">contact@qinglvcinema.com</p>
            </div>

            <div className="bg-background-50 rounded-2xl p-6 border border-secondary-200/70">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className="ri-chat-smile-2-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-700 mb-2">意见反馈</h3>
              <p className="text-foreground-500 text-sm">feedback@qinglvcinema.com</p>
            </div>

            <div className="bg-background-50 rounded-2xl p-6 border border-secondary-200/70">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                <i className="ri-briefcase-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-700 mb-2">商务合作</h3>
              <p className="text-foreground-500 text-sm">biz@qinglvcinema.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}